var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"2","height":"59","viewBox":"0 0 2 59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 0.908203V58.2693","stroke":"#858C9A","stroke-opacity":"0.4","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"2 2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }